import { render } from "./StudentAvatar.vue?vue&type=template&id=bd962d38"
import script from "./StudentAvatar.vue?vue&type=script&lang=js"
export * from "./StudentAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__